import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export class GclidDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.GCLID, apiHelper);
    }
}